import Roles from "@/enums/Roles.js";

export default [
  {
    link: "/",
    text: "menu.dashboard",
    icon: "mdi-view-dashboard-outline",
    permission: "*",
  },
  {
    link: "/users",
    text: "menu.users",
    icon: "mdi-account-outline",
    permission: `${Roles.ADMIN}`,
  },
  {
    link: "/projects",
    text: "menu.projects",
    icon: "mdi-database",
    permission: `${Roles.ADMIN}`,
  },
  {
    link: "/logs",
    text: "menu.logs",
    icon: "mdi-history",
    permission: `${Roles.ADMIN}`,
  },
  {
    link: "/request-logs",
    text: "menu.requests",
    icon: "mdi-lan-connect",
    permission: `${Roles.ADMIN}`,
  },
  {
    link: "/tokens",
    text: "menu.tokens",
    icon: "mdi-shield-key-outline",
    permission: `${Roles.CLIENT}`,
  },
  {
    link: "/apis",
    text: "menu.apis",
    icon: "mdi-api",
    permission: `${Roles.CLIENT}`,
  },
];
